import { ITaxAuthoritiesState } from './types';

export const selectSyncState = (state: ITaxAuthoritiesState) => state.syncing;
export const selectLoadedState = (state: ITaxAuthoritiesState) => state.loaded;
export const selectSyncError = (state: ITaxAuthoritiesState) => state.error;

export const selectTaxAuthorities = (state: ITaxAuthoritiesState) => state.taxAuthorities;
